<template>
  <div class="pc-course">
    <BreadCrumb :data="breadcrumb" :title="'展馆列表管理'" />
    <StatisticalPanel
      :whichModule="'exhibition'"
      :data="overallData"
    ></StatisticalPanel>
    <ExhibitionTable />
    <div class="pc-list" ref="list">
      <h2 class="pc-banner-title">展馆banner管理</h2>
      <button
        @click="exhibitionTop()"
        class="btnViewDetail1"
        ref="changeButton"
      >
        修改
      </button>
      <el-table class="pc-list-table" :data="bannerList">
        <el-table-column fixed prop="id" label="ID" width="170">
          <template slot-scope="scope">
            <span v-show="exhibitionStatus != scope.$index">
              {{ scope.row.id }}
            </span>
            <el-input
              v-model="scope.row.id"
              v-show="exhibitionStatus == scope.$index"
              placeholder=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column width="150">
          <template slot-scope="scope">
            <button
              v-if="exhibitionStatus == scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="exhibitionDetail(scope)"
            >
              查看
            </button>
          </template>
        </el-table-column>
        <el-table-column prop="cover_image" label="图片" width="170">
          <template slot-scope="scope">
            <img :src="scope.row.cover_image" alt="" class="cover_images" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="230">
          <template slot-scope="scope">
            <span>{{ scope.row.chinese_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="简介" width="230">
          <template slot-scope="scope">
            <span>{{ scope.row.chinese_introduce }}</span>
          </template>
        </el-table-column>

        <el-table-column width="220">
          <template slot-scope="scope">
            <button
              v-show="exhibitionStatus != scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="viewDetail(scope.row, scope.$index)"
            >
              修改
            </button>
            <button
              v-show="exhibitionStatus == scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="finishDetail(scope.row)"
            >
              完成
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel";
import ExhibitionTable from "./component/ExhibitionTable";
import {
  getExhibitionCount_Api,
  getWorksCount_Api,
  exhibitionTop_Api,
  getExhibitionTop_Api,
  getExhibitionDetail_Api,
} from "../../../apis/exhibition.api";
export default {
  data() {
    return {
      overallData: {
        title: "课程数据",
        count: [
          { name: "展馆数量", count: null },
          { name: "作品数量", count: null },
        ],
      },
      bannerList: [],
      exhibitionStatus: -1,
      exhibition: {
        exhibition_id: null,
      },
      rankType: "update",
      position: null,
      id: null,
      exhibition_top_list: [],
    };
  },
  components: {
    BreadCrumb,
    ExhibitionTable,
    StatisticalPanel,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "展馆列表", link: "/admin/exhibitionList" },
      ];
    },
  },
  mounted() {
    getExhibitionCount_Api().then((res) => {
      console.log(res);
      this.$set(this.overallData.count[0], "count", res.count);
    });
    getWorksCount_Api().then((res) => {
      console.log(res);
      this.$set(this.overallData.count[1], "count", res.count);
    });
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      getExhibitionTop_Api().then((res) => {
        this.bannerList = res.data;
        console.log(res);
      });
    },
    viewDetail(item, index) {
      this.rankType = "update";
      this.exhibitionStatus = index;
      console.log(this.$refs.changeButton.innerHTML);
      this.$refs.changeButton.innerHTML = "完成";
      this.id = item.id;
      console.log(item.id);
      console.log(index);
    },
    finishDetail() {
      this.exhibitionStatus = -1;
    },
    exhibitionDetail(item) {
      getExhibitionDetail_Api(item.row.id).then((res) => {
        this.exhibition = res.data;
        console.log(res);
        console.log(item.$index);
        console.log(this.bannerList);
        this.$set(this.bannerList, item.$index, res.data);
      });
    },
    exhibitionTop() {
      for (let i = 0; i < this.bannerList.length; i++) {
        console.log(this.bannerList[i].id);
        this.exhibition_top_list.push(this.bannerList[i].id);
      }
      console.log(this.exhibition_top_list);

      exhibitionTop_Api({ exhibition_top_list: this.exhibition_top_list }).then(
        (res) => {
          console.log(res);
          this.$global.success(this, "修改成功！", null);
          this.getBannerList();
        }
      );
      this.$refs.changeButton.innerHTML = "修改";
      this.exhibition_top_list = [];
    },
  },
};
</script>



<style lang="scss"  scoped>
.pc-list {
  padding: 42px 30px 57px;
  margin-top: 20px;
  margin-bottom: 30px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  overflow: hidden;
  position: relative;
  .pc-banner-title {
    display: inline-block;
    font-size: 20px;
    padding: 0 0 30px 0;
    -ms-flex-item-align: end;
    align-self: flex-end;
  }
  .btnViewDetail1 {
    position: absolute;
    right: 40px;
    top: 40px;
    width: 90px;
    height: 35px;
    background: #5470c6;
    border-radius: 2px;
    outline: none;
    border: none;
    font-family: "PingFangSC-Regular";
    font-size: 14px;
    color: white;
    cursor: pointer;
  }
  .btnViewDetail1:hover {
    background: $blueBtn;
    color: white;
  }
  .pc-list-head {
    // margin-top: 20px;
    // margin-bottom: 30px;
    margin: 20px 0 30px;
    border-top: 1px solid #c0c0c0;
    padding-top: 30px;
    letter-spacing: 1px;
    font-family: $chinese;
    font-size: 14px;
    color: $mainTitle;
    display: flex;
    justify-content: flex-end;
    .pc-list-head-handle {
      // float: right;
      display: flex;
      align-items: center;
      .pc-list-head-btn {
        display: flex;
        border: 1px solid $schoolTagBorder;
        margin-right: 30px;
        border-radius: 4px;
        button,
        p {
          cursor: pointer;
          font-family: $chinese;
          font-size: 14px;
          color: $mainTitle;
          letter-spacing: 1px;
        }
        button {
          width: 100px;
          background: none;
          outline: none;
          padding: 10px 0px;
          box-sizing: content-box;
          border: none;
        }
        span {
          height: 16px;
          border: 1px solid $schoolTagBorder;
          align-self: center;
        }
        button:hover {
          background: $blueBtn;
          color: white;
        }
        p {
          margin-left: 32px;
        }
      }
    }
  }

  /deep/ .el-table__row {
    height: 60px;
    .el-input {
      .el-input__inner {
        height: 30px;
        text-align: center;
        width: 80px;
      }
      .el-select__caret {
        line-height: 30px;
      }
    }
    .el-input--suffix {
      .el-input__inner {
        width: 100%;
      }
    }
  }
  .pc-list-table::-webkit-scrollbar {
    height: 10px;
    background: red;
  }
  .pc-list-table {
    overflow: visible !important;
    .btnViewDetail {
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid $timeBtn;
      outline: none;
      background: none;
      font-family: $chinese;
      font-size: 12px;
      color: $timeBtn;
      cursor: pointer;
    }
    .btnViewDetail:hover {
      background: $blueBtn;
      color: white;
    }
    /deep/ .cell {
      text-align: center !important;
      font-family: $chinese !important;
      font-size: 14px !important;
      color: $mainTitle !important;
      .el-icon-error {
        font-size: 18px;
        margin-right: 20px;
        color: $fork;
      }
      .el-icon-success {
        font-size: 18px;
        color: $blueBtna;
      }
    }

    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
    .switch-is-active {
      /deep/ .el-switch__core {
        &::before {
          content: "有效";
          font-size: 8px;
          color: white;
          padding-left: 6px;
        }
      }
    }
    .cover_images {
      width: 70px;
      height: 45px;
    }
    .switch-is-not-active {
      /deep/ .el-switch__core {
        &::before {
          content: "无效";
          font-size: 8px;
          color: white;
          padding-left: 22px;
        }
      }
    }
    /deep/ .el-table__body-wrapper {
      min-height: 100px;
    }
    /deep/ .is-leaf {
      border-top: 1px solid #ebeef5;
      background: $base-color !important;
      font-weight: normal !important;
    }
    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
  }

  .pagination {
    margin-top: 40px;
  }
  /deep/ .pc-pagin {
    justify-content: flex-end !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/ExhibitionList.vue